// extracted by mini-css-extract-plugin
module.exports = {"addQuickBooksDesktopWindow":"addQuickBooksDesktopWindow__IN8iI","img":"img__iwrZy","text":"text__jzIR-"};